export class Email {
  id: number;
  perfil: string;
  email: string;
  emailsDepto: { [chave: number]: string };
  lista: { [chave: number]: string };
}



// WEBPACK FOOTER //
// ./src/app/configuracoes/email.ts